export default __webpack_public_path__ + "static/media/telegram.efd90580.svg";